import type { PropsWithChildren } from "react";
import React from "react";
import * as styles from "./QuizLayout.css";

export const QuizLayout: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className={styles.quizLayout} data-testid="QuizLayout">
      <div className={styles.layoutWrapper}>
        <div className={styles.quizPagesWrapper}>{children}</div>
      </div>
    </div>
  );
};
